










import {
    Component,
    ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition,
    InjectComponent, Mixins,
    Prop,
    LongTextQuestion,
    VueComponent
} from "@zoovu/runner-browser-api";
import {QuestionConfiguration} from "../configuration";
import QuestionBaseMixin from "./question-base.vue";

@Component({})
export default class LongTextQuestionView extends Mixins(QuestionBaseMixin) {

    @Prop()
    question: LongTextQuestion;

    @ComponentConfig(QuestionConfiguration)
    componentConfiguration: QuestionConfiguration;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("QuestionValidationMessageView")
    questionValidationMessageView: VueComponent;

    get answerText() {
        return this.question.answerText;
    }

    set answerText(text: string) {
        this.question.setAnswerText(text);
    }
}
